import React from 'react';

/**
 * The meta strip used at the top of a detail drawer — a single card holding a
 * grid of label/value cells.
 *
 * This is the shape the agent-run drawer established (RunMetaTags): no card,
 * the cells sit on the drawer's surface in a grid that fits as many columns
 * as the width allows, each a quiet caption above its value. Events and Sessions now
 * render the same thing so a detail popup reads identically wherever you opened
 * it from.
 *
 * Pass `cells` as `{ label, content }`, filtering falsy entries at the call site
 * the way RunMetaTags does — a cell with no value should be absent, not empty.
 */

/** One cell — caption on top, value below. */
export function MetaCell({ label, children, title }) {
  return (
    <div className="flex min-w-0 flex-col gap-1">
      <span className="text-[11px] text-[color:var(--text-muted)]">
        {label}
      </span>
      <div className="truncate text-[13px] text-[color:var(--text-primary)]" title={title}>
        {children}
      </div>
    </div>
  );
}

// eslint-disable-next-line no-unused-vars
export default function MetaGrid({ cells = [], columns = 5, className = '' }) {
  if (!cells.length) return null;
  return (
    <div className={className}>
      <div className="grid gap-x-6 gap-y-4" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))' }}>
        {cells.map((cell, i) => (
          <MetaCell key={cell.label || i} label={cell.label} title={cell.title}>
            {cell.content}
          </MetaCell>
        ))}
      </div>
    </div>
  );
}
